import state from './state'
import getters from './getters'
import actions from './actions'
import mutations from './mutations'

export const billing = {
  namespaced: true,
  state: state(),
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/billing/index.js